<div [id]="dynamicDivId" [ngClass]="message.makeHighlighted ? 'highlighted-message': '' " *ngFor="let message of conversation.messages; let i=index">
  <div [ngClass]="message.isInitialMessage? 'initialMessage' : 'otherMessage'" [class.support-row]="isSupportMessage(message)"
       [matTooltip]="supportTooltip(message)" [matTooltipDisabled]="!isSupportMessage(message)"
       matTooltipClass="support-row-tooltip" [matTooltipShowDelay]="300"
       class="flex flex-col justify-start items-start">
    <div *ngIf="isSupportMessage(message)" class="support-row-label">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
           stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"></path>
        <path d="M21 16v2a4 4 0 0 1-4 4h-5"></path>
      </svg>
      <span>{{ supportRowLabel(message) }}</span>
    </div>
    <div class="flex flex-row" >
      <collaboration-avatar [gravatarInfo]="message?.createdBy"></collaboration-avatar>
      <div class="flex flex-col">
        <div *ngIf="message.isInitialMessage" class="comment"
             (click)="contextClickedHandler($event, message.id)"
             [innerHTML]="message.message | sanitizeHtml"></div>
        <!--<a *ngIf="!message.showFullMessage && message.isInitialMessage" (click)="showMoreMessage(message)" class="show-more">Show more</a>-->
      </div>
      <div *ngIf="!message.isInitialMessage" class="comment">
        <a id="[User][{{message?.createdBy?.email}}]"
           (click)="contextClickedHandler($event, message.id)">{{message?.createdBy.firstName}} {{message?.createdBy.lastName}}</a>
        replied:
      </div>
    </div>
    <div class="content-container flex flex-col justify-start items-start">
      <div class="flex flex-row" *ngIf="!message.isDeleted">
        <div class="flex flex-col">
          <div class="comment">
            <div class="comment-content" [id]="dynamicDivId+message.id" *ngIf="!message.isInitialMessage"
                 (click)="contextClickedHandler($event, message.id)" [innerHTML]="message.message | sanitizeHtml"></div>
            <!--<a *ngIf="!message.showFullMessage && !message.isInitialMessage" (click)="showMoreMessage(message)" class="show-more">Show more</a>-->
            <div class="add-comment-container m-b-6" *ngIf="message.isInitialMessage && message.attachment"
                 (click)="contextClickedHandler($event, message.id)"
                 [innerHTML]="message.attachment ?? '' | sanitizeHtml"></div>
            <!--<a *ngIf="!message.showFullAttachment && message.isInitialMessage" [id]="dynamicDivId+message.id" (click)="showMoreAttachment(message)" class="show-more">Show more</a>-->
            <span *ngIf="message.isEdited" class="edited">(Edited)</span>
          </div>
        </div>
      </div>
      <div *ngIf="message.isDeleted" class="m-l-30 m-t-14 m-b-10 flex flex-row justify-start items-start">
        <i class="far fa-exclamation-circle m-r-3"></i>This reply has been removed
      </div>
      <div class="comment-footer m-l-34 flex flex-row justify-start items-center">
        <div class="timing">{{message.createdDate | date:'d MMM yyyy h:mm a'}}</div>
        <particle-dynamic-tooltip-container *ngIf="i===0 && !isMagicLinkOnly && !hideGotoPage"
                                            [openOption]="'hover'"
                                            [position]="'bottom'"
                                            [htmlElement]="gotoBtnHoverMessage"
                                            [theme]="'dark'">
          <button [disabled]="hasShareId || isMagicLinkUser"
                  [ngClass]="message.isInitialMessage? 'go-to-page-button' : 'hide'" class="m-l-5"
                  (click)="onChangeReplyMenuItem('GoToPage', message)">
            <i class="fas fa-arrow-circle-right"></i>
          </button>
        </particle-dynamic-tooltip-container>
        <button class="icon-dropdown-button m-l-4" *ngIf="!message.isTemporary" mat-icon-button
                [matMenuTriggerFor]="chatReplyMenu">
          <i class="fal fa-ellipsis-h"></i>
        </button>
      </div>
      <div *ngIf="i===0" class="m-l-34 m-t-13 flex flex-row justify-start items-center">
        <a class="link-color link-button" (click)="onChangeReplyMenuItem('Reply', message)">
          Add a reply
        </a>
      </div>
    </div>
    <mat-menu class="activity-menu right" #chatReplyMenu="matMenu" [overlapTrigger]="false">
      <button mat-menu-item (click)="onChangeReplyMenuItem('Reply', message)" class="flex flex-row justify-start items-center">
        <i class="far fa-comment-alt-lines"></i>
        <span>{{'Comment/Reply'}}</span>
      </button>
      <button *ngIf="!isMagicLinkOnly && !message.isInitialMessage && message.isMine && !message.isDeleted"
              mat-menu-item (click)="onChangeReplyMenuItem('Edit', message)" class="flex flex-row justify-start items-center">
        <i class="far fa-pen-nib"></i>
        <span>Edit</span>
      </button>
      <button *ngIf="!isMagicLinkOnly && !message.isInitialMessage && message.isMine && !message.isDeleted"
              mat-menu-item (click)="onChangeReplyMenuItem('Delete', message)" class="flex flex-row justify-start items-center">
        <i class="far fa-trash"></i>
        <span>Delete</span>
      </button>
      <!-- <button *ngIf="!isMagicLinkOnly" mat-menu-item (click)="onChangeReplyMenuItem('ShowActivityOnDate', message)"
      class="flex flex-row justify-start items-center">
        <i class="far fa-clock"></i>
        <span>Show Activities on {{message.createdDate | date:'d MMM yyyy'}} </span>
      </button> -->
      <!--      <button mat-menu-item (click)="onChangeReplyMenuItem('GoToPage', message)" fxLayout="row" fxLayoutAlign="start center">-->
      <!--        <i class="far fa-directions"></i>-->
      <!--        <span>Go to Page</span>-->
      <!--      </button>-->
      <!--      <button mat-menu-item (click)="onChangeReplyMenuItem('Archive', message)" fxLayout="row" fxLayoutAlign="start center">
              <i class="far fa-archive"></i>
              <span>Archive</span>
            </button>
      <!--      <button mat-menu-item (click)="onChangeReplyMenuItem('Details', message)" fxLayout="row" fxLayoutAlign="start center">
              <i class="far fa-info-circle"></i>
              <span>Details</span>
            </button>
            <button mat-menu-item fxLayout="row" fxLayoutAlign="start center">
              <i class="far fa-external-link-square"></i>
              <span>Go to Item</span>
            </button>-->
    </mat-menu>
  </div>
</div>
<a (click)="viewMoreMessages()" *ngIf="conversation && conversation.messageCount - conversation.messages?.length >= 0"
   class="show-more m-b-15 m-l-64" style="display: block">View more replies<i class="fas fa-chevron-down"></i></a>
<particle-text-editor
  [id]="textEditorId"
  *ngIf="showEditor"
  [editorId]="'_'+textEditorId"
  [chatText]="messageText"
  [allContacts]="allContacts"
  [hashTagList]="hashTagList"
  [hideDac6CardLink]="true"
  [replyToMessage]="replyToMessage"
  [focusEditor$]="focusEditorOnChatEditor$"
  [placeholder]="'Add a reply...'"
  [disableEnterToSendMessage]="true"
  (cancelReplyEvent)="onCancelReply($event)"
  (outputChatEditorEvent)="sendMessage($event)"
  (cancelChatEditor)="onCancelChatEditor($event)"
  (outputEditorInnerHtmlOnChangeEvent)="onEditorValueChange($event)"
  [mention$]="mention$"
>
</particle-text-editor>
